import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  "@keyframes appear-split-and-travel": {
    "0%": {
      transform: "translate(0, 0) scale(0)",
      opacity: 0,
    },
    "15%": {
      transform: "translate(0, 0) scale(1)",
      opacity: 1,
    },
    "40%": {
      transform: "translate(var(--reveal-x), var(--reveal-y)) scale(0.8)",
      opacity: 1,
    },
    "100%": {
      transform: "translate(90vw, -50vh) scale(0)",
      opacity: 0,
    },
  },
  container: {
    position: "absolute",
    bottom: "52%",
    left: "40%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10000,
    pointerEvents: "none",
  },
  particle: {
    position: "absolute",
    animationName: "$appear-split-and-travel",
    animationTimingFunction: "cubic-bezier(0.3, 0, 0.3, 1)",
    animationFillMode: "forwards",
  },
  gemIcon: {
    width: 40,
    height: 40,
  },
});
